import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_segment_ext_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    line_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file: fromDatatype.TextDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_dgmkt_segment_ext_RowClass implements bl_dgmkt_segment_ext_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    line_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    ext_type: fromDatatype.VarcharDatatypeInterface;
    ext_code: fromDatatype.VarcharDatatypeInterface;
    ext_option: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file: fromDatatype.TextDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}